import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation GenerateZipMutation($input: GenerateZipInput!) {
    generateZip(input: $input) {
      url
    }
  }
`;

function commit(environment, eventId, type, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        eventId,
        type,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.generateZip.url);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
